$(document).ready(function () 
{
    if ($('.sortable-table').length)
    {
        $('.sortable-table').dataTable(
        {
            "searching": false,
            "info": false,
            "pageLength": 50,
            "paging": false
        });
    }
    if ($('.sort-table-no-order').length)
    {
        $('.sort-table').dataTable(
        {
            "searching": false,
            "info": false,
            "pageLength": 50,
            "paging": false,
            "ordering": false
        });
    }
    if ($('.js-data-table').length)
    {
        $('.js-data-table').dataTable({
            searching: true,
            info: true,
            bLengthChange: false,
            paging: true,
            columnDefs: [
                {targets: 'no-sort', orderable: false}
            ],
            dom: 'Bfrtip',
            buttons: [
                $.extend(true, {}, {
                    extend: 'excelHtml5'
                })
                // $.extend( true, {}, {
                //     extend: 'pdfHtml5'
                // } )
            ],
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search...",
                paginate: {
                    "previous": "&lsaquo;",
                    "next": "&rsaquo;"
                }
            },
            initComplete: function () {

                var filters_div = $('.js-data-table__filters');

                this.api().columns().every(function () {

                    var column = this;
                    var header = column.header().innerText;
                    if (header.trim().length) {
                        var select = $('<select class="filter-' + header.toLowerCase().trim() + '"><option value="">Sort by ' + header + '</option></select>').appendTo(filters_div).on('change', function () {

                            var val = $.fn.dataTable.util.escapeRegex($(this).val());

                            column.search(val ? '^' + val + '$' : '', true, false).draw();
                        });

                        column.data().unique().sort().each(function (d, j) {
                            select.append('<option value="' + d + '">' + d + '</option>')
                        });
                    }

                });

                $('.dataTables_filter').appendTo(filters_div)
            }
        });
    }


    if ($('.sortable-table-none-excel').length)
    {

        var dateNow = new Date();
        var dateStr = dateNow.toUTCString()
        var the_title = "Social Value Download"  + dateStr;

        $('.sortable-table-none-excel').dataTable(
        {
            "searching": true,
            "info": false,
            "paging": false,
            "order": [[ 0, "asc" ]],
            "dom": 'Blfrtip',
            "buttons": 
            [  
                { 
                    "extend" : "excelHtml5",
                    "filename" : the_title,
                    "text": 'Save as Excel',
                    "title" : $(this).data("file-title"),
                    "exportOptions": {
                        format: 
                        {
                            body: function ( data, row, column, node ) {
                                if( typeof $(node).data('excel-version') !== 'undefined'){
                                    data = $(node).data('excel-version');
                                }                 
                                return data;
                            }              
                        },
                        rows: function(idx, data, node) 
                        {
                            //console.log($(node).attr('style'))
                            if ( $(node).attr('style') == 'display: none;') 
                            {
                                return false;
                            }
                            return true;
                        }
                    },
                }
            ],            
        });
    

    } 
});